import { create } from "zustand";

interface LiveDataPanelStore {
  deviceId: string | null;
  openLiveDataPanel: (deviceId: string) => void;
  closeLiveDataPanel: () => void;
}

export const useLiveDataPanelStore = create<LiveDataPanelStore>((set) => ({
  deviceId: null,
  openLiveDataPanel: (deviceId: string) => set({ deviceId }),
  closeLiveDataPanel: () => set({ deviceId: null }),
}));
